import React from 'react';
import { connect } from 'react-redux';
import {
  Divider,
  Table,
} from 'semantic-ui-react';

export default function TermLedger(props) {
  const { term } = props;

  if (!term) {
    return null;
  }

  return (
    <div style={{ margin: '12px 0' }}>
      <div className="ledger-header">
        <div>
          <p>
            <span className="ledger-number">${term.cash_total}</span>
            (Cash Total)
          </p>
          <p>
            <span className="ledger-number">${term.minimum_purchase_reserve}</span>
            (Minimum Cost Reduction)
          </p>
          <p>
            <span className="ledger-number">{term.tax_rate}%</span>
            (Tax Rate)
          </p>
          <p>
            <span className="ledger-number">{term.term} months</span>
            (Term)
          </p>
        </div>
      </div>
      <div className="ledger">
        <div>
          <p>
            <span className="ledger-number">${term.total_purchase_reserve}</span>
            (Cost Reduction Made)
          </p>
          <p className="ledger-operator">-</p>
          <p>
            <span className="ledger-number">${term.tax_on_deposit}</span>
            (Tax On Reduction)
          </p>
          <p className="ledger-operator">=</p>
          <p>
            <span className="ledger-number">${term.cost_reduction_after_tax}</span>
            (Cost Reduction After Tax)
          </p>
        </div>
        <div>
          <p>
            <span className="ledger-number">${term.cost_reduction_after_tax}</span>
            (Cost Reduction Applied)
          </p>
          <p className="ledger-operator">-</p>
          <p>
            <span className="ledger-number">${term.cash_total}</span>
            (Cash Total)
          </p>
          <p className="ledger-operator">=</p>
          <p>
            <span className="ledger-number">${term.final_cost_of_unit}</span>
            (Pre-Tax Cash Total)
          </p>
        </div>
        <div>
          <p>
            <span className="ledger-number">${term.monthly_pretax}</span>
            (Monthly Pre-Tax Payment)
          </p>
          <p className="ledger-operator">+</p>
          <p>
            <span className="ledger-number">${term.monthly_tax}</span>
            (Monthly Tax On Payment)
          </p>
          <p className="ledger-operator">=</p>
          <p>
            <span className="ledger-number">${term.total_monthly_payment}</span>
            (Total Monthly Commitment)
          </p>
        </div>
        <div>
          <p>
            <span className="ledger-number">${term.total_monthly_payment}</span>
            (Total Monthly Commitment)
          </p>
          <p className="ledger-operator">x</p>
          <p>
            <span className="ledger-number">{term.term} months</span>
            (Full Term)
          </p>
          <p className="ledger-operator">=</p>
          <p>
            <span className="ledger-number">${term.full_term_payoff}</span>
            (Total Contract If Full Term)
          </p>
        </div>
      </div>
    </div>
  );
}
